import { Component, OnInit, OnChanges, Input, Output, EventEmitter, } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { CaseService } from '../../../service/case/case.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9213',
  templateUrl: 'wa9213.component.html',
  styleUrls: ['wa9213.component.scss']
})
export class Wa9213Component implements OnInit {
  public componentTitle = 'WA9213:ケースマスタ修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public caseCd = '';
  public caseTx = new FormControl('', [Validators.required, Validators.maxLength(validation.caseTx.maxLength)]);
  private updcounterNr:number;
  // build FormGroup

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private caseTxCls = '';
  private item = null;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private ownerService: OwnerService,
    private caseService: CaseService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() { }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    var caseTx = this.caseTx.value.trim();
    let errors = false;
    if (this.caseTx.errors !== null) {
      this.caseTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.caseService
      .put(this.caseCd, caseTx, this.updcounterNr, 'wa9213')
      .then(outputJson => {
        this.working = false;
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '修正が完了しました');
        }
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const rowCase: object = JSON.parse(sessionStorage.getItem('rowCase'));
    this.item = rowCase;

    this.caseCd = rowCase['caseCd'];
    this.caseTx.setValue(rowCase['caseTx']);
    this.updcounterNr = rowCase['updcounterNr'];

    this.isSubmitButtonEnabled = false;
    console.log(this.item)
  }

  ngDoCheck() {
    if (!this.isShow)
      return;
    this.caseTxCls = this.caseTx.value === this.item['caseTx'] ? '' : (this.caseTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled = (this.caseTxCls == this.STRINGS_ERROR) ? false : (
      this.caseTxCls == this.STRINGS_ACTIVE);
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9213/wa9213.component.ts